import { useEffect, useState } from "react";
import Error from "../Error/Error";
import InitialPayment from "../InitialPayment";
import { useNavigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const [isActive, setIsActive] = useState(null);
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_CAPITALYA_API_URL;
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      return;
    }

    const checkAccess = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/api/activation/control-access`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // 🔴 TOKEN INVALIDE / EXPIRÉ
        if (response.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");

          navigate("/dashboard/auth/login", {
            state: { message: "Session expirée. Veuillez vous reconnecter." }
          });
          return;
        }

        const data = await response.json();
        setLoading(true);
        setIsActive(data.isActive);

      } catch (error) {
        console.error("Erreur:", error);
        setIsActive(false);
      }
    };

    checkAccess();
  }, [token, apiUrl, navigate]);

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      const res = await fetch(`${apiUrl}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      localStorage.setItem("user", JSON.stringify(data.user));
      // setUser(data.user);
    };

    fetchUser();
  }, [apiUrl]); 


  if (!token) return <Error />;
  if (isActive) { return children }
  if (!isActive) {
    setTimeout(() => {
      setLoading(false);
    }, 1500);
    // return children;
    return loading ? <p>Chargement...</p> : <InitialPayment />;
  }
  return children;
}
